import {
  PAGE_ROUTE_ROLES_AND_ACCESS,
  PAGE_ROUTE_USER_GUIDE,
  PAGE_ROUTE_BLOG,
  PAGE_ROUTE_SOPS
} from "@kivunova/kivufrontendcommon";
import { KIVUNOVA_WEBSITE_PATHS } from "../../constants/kivunovaWebsite";

export type WelcomeFooterLink = {
  id: string;
  labelKey: string;
  labelFallback: string;
  route?: string;
  href?: string;
  kivunovaPath?: string;
};

export type WelcomeFooterColumn = {
  id: string;
  titleKey: string;
  titleFallback: string;
  links: WelcomeFooterLink[];
};

export const WELCOME_FOOTER_COLUMNS: WelcomeFooterColumn[] = [
  {
    id: "learn",
    titleKey: "welcome-footer-learn-title",
    titleFallback: "Learn about",
    links: [
      {
        id: "who-we-are",
        labelKey: "welcome-footer-who-we-are",
        labelFallback: "Who we are",
        kivunovaPath: KIVUNOVA_WEBSITE_PATHS.whoWeAre
      },
      {
        id: "our-services",
        labelKey: "welcome-footer-our-services",
        labelFallback: "Our services",
        kivunovaPath: KIVUNOVA_WEBSITE_PATHS.ourServices
      },
      {
        id: "our-team",
        labelKey: "welcome-footer-our-team",
        labelFallback: "Our team",
        kivunovaPath: KIVUNOVA_WEBSITE_PATHS.ourTeam
      }
    ]
  },
  {
    id: "resources",
    titleKey: "welcome-footer-resources-title",
    titleFallback: "Resources",
    links: [
      {
        id: "user-guide",
        labelKey: "welcome-footer-user-guide",
        labelFallback: "User guide",
        route: PAGE_ROUTE_USER_GUIDE
      },
      {
        id: "roles-and-access",
        labelKey: "welcome-footer-roles-and-access",
        labelFallback: "Roles & access",
        route: PAGE_ROUTE_ROLES_AND_ACCESS
      },
      {
        id: "sops",
        labelKey: "welcome-footer-sops",
        labelFallback: "Run books",
        route: PAGE_ROUTE_SOPS
      },
      {
        id: "learn-more",
        labelKey: "welcome-footer-learn-more",
        labelFallback: "Learn more",
        route: PAGE_ROUTE_BLOG
      },
      {
        id: "privacy",
        labelKey: "welcome-footer-privacy",
        labelFallback: "Privacy policy",
        kivunovaPath: KIVUNOVA_WEBSITE_PATHS.privacy
      }
    ]
  },
  {
    id: "contact",
    titleKey: "welcome-footer-contact-title",
    titleFallback: "Contact us",
    links: [
      {
        id: "phone",
        labelKey: "welcome-footer-phone",
        labelFallback: ""
      },
      {
        id: "email",
        labelKey: "welcome-footer-email",
        labelFallback: ""
      },
      {
        id: "message",
        labelKey: "welcome-footer-send-message",
        labelFallback: "Send us a message",
        kivunovaPath: KIVUNOVA_WEBSITE_PATHS.contactUs
      }
    ]
  }
];
